import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Switcher from "../../components/switcher";

export default function Privacy(){
    return(
        <>
        <Navbar navclass="defaultscroll is-sticky" navlight={false} manuclass="justify-end"/>

        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Política de Privacidad</h3>
                </div>
            </div>

            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-red-500"><Link to="/">Chile-Turismo.cl</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-red-500" aria-current="page">Privacidad</li>
                </ul>
            </div>
        </section>

        <section className="relative md:py-24 py-16">
            <div className="container relative">
                <div className="md:flex justify-center">
                    <div className="md:w-3/4">
                        {/* Aviso de borrador legal */}
                        <div className="mb-6 p-4 rounded-md border border-amber-400 bg-amber-50 dark:bg-amber-500/10 text-amber-800 dark:text-amber-200 font-semibold text-center">
                            BORRADOR — pendiente de revisión legal
                        </div>

                        <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">
                            <p className="text-slate-400">
                                En Chile-Turismo.cl protegemos tus datos personales conforme a la Ley N° 19.628 sobre
                                Protección de la Vida Privada. Esta política describe qué datos recolectamos, con qué
                                finalidad y cómo los tratamos.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">1. Datos que recolectamos</h5>
                            <p className="text-slate-400">
                                Recolectamos los datos que nos entregas al reservar o contactarnos: nombre, correo
                                electrónico, teléfono, documento de identidad o pasaporte y los antecedentes de tu
                                reserva. Durante el check-in registramos además la aceptación de la cláusula de
                                participación y tu firma digital, junto con metadatos técnicos (fecha, hora y dirección IP)
                                con fines de verificación.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">2. Finalidad del tratamiento</h5>
                            <p className="text-slate-400">
                                Utilizamos tus datos para gestionar reservas y pagos, coordinar la prestación del tour,
                                enviar confirmaciones y recordatorios, emitir comprobantes y responder tus consultas. No
                                vendemos tus datos personales a terceros.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">3. Pagos y proveedores</h5>
                            <p className="text-slate-400">
                                Los pagos se procesan a través de pasarelas de terceros (por ejemplo, Webpay), quienes
                                tratan los datos de pago bajo sus propias políticas. Los datos de la tarjeta no se
                                almacenan en nuestros servidores.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">4. Comunicaciones y almacenamiento</h5>
                            <p className="text-slate-400">
                                Para el envío de correos utilizamos servicios de entrega de correo (Amazon SES) y, para el
                                alojamiento de imágenes y archivos, servicios de almacenamiento en la nube (Amazon S3). Estos
                                proveedores tratan la información únicamente para prestar dichos servicios.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">5. Tus derechos (ARCO)</h5>
                            <p className="text-slate-400">
                                Puedes ejercer tus derechos de acceso, rectificación, cancelación y oposición sobre tus
                                datos personales escribiendo a <a href="mailto:turismo@cmsystem.cl" className="text-red-500">turismo@cmsystem.cl</a>.
                                Atenderemos tu solicitud conforme a la legislación vigente.
                            </p>

                            <h5 className="text-xl font-semibold mb-4 mt-8">6. Cambios en esta política</h5>
                            <p className="text-slate-400">
                                Podremos actualizar esta política para reflejar cambios legales u operativos. La versión
                                vigente estará siempre disponible en este sitio.
                            </p>

                            <div className="mt-8">
                                <Link to="/" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-red-500 hover:bg-red-600 border-red-500 hover:border-red-600 text-white rounded-md">Volver</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}
